import React, { FC, PropsWithChildren } from 'react'
import { IProduct } from '../../types/IProduct'
import { useCart } from '../../contexts/CartContext'
import Button from '../units/Button/Button'

interface IProductAddToCartProps {
  product: IProduct
  quantity?: number
}

const ProductAddToCart: FC<PropsWithChildren<IProductAddToCartProps>> = (props) => {
  const { product, quantity = 1 } = props

  const cart = useCart()

  const handleAddToCart = () => {
    cart.addToCart(product.id, quantity)

    if (window.innerWidth > 720) {
      cart.setIsVisibleCart(true)

      setTimeout(() => {
        document.querySelector('#cart ul')!.scrollTo({ top: 999_999 })
      }, 10)
    }
  }

  const isInCart = cart.cartProducts.some((item) => product.id === item.data.id)

  return (
    <Button onClick={handleAddToCart} disabled={isInCart}>
      {isInCart ? 'В корзине' : 'Добавить'}
    </Button>
  )
}

export default ProductAddToCart
